/* global gtag, dataLayer */
import { useEffect } from 'react';

const CookieConsent = () => {
  useEffect(() => {
    const initializeCookieConsent = () => {
      if (window.silktideCookieBannerManager && window.silktideCookieBannerManager.updateCookieBannerConfig) {
        console.log('Initializing cookie consent banner...');
        
        // Check localStorage for initial choice
        const initialChoiceKey = 'silktideCookieBanner_InitialChoice';
        const hasInitialChoice = localStorage.getItem(initialChoiceKey) !== null;
        console.log('Has initial choice in localStorage:', hasInitialChoice);
        
        // Only show banner if user hasn't made a choice yet
        // If initial choice exists, respect it and don't show banner
        const shouldShowBanner = !hasInitialChoice;
        console.log('Should show banner:', shouldShowBanner);
        
        window.silktideCookieBannerManager.updateCookieBannerConfig({
          showBanner: shouldShowBanner, // Only show banner if no initial choice exists
          background: {
            showBackground: true
          },
          cookieIcon: {
            position: "bottomLeft"
          },
          cookieTypes: [
            {
              id: "necessary",
              name: "Necessary",
              description: "<p>These cookies are necessary for the website to function properly and cannot be switched off. They help with things like logging in and setting your privacy preferences.</p>",
              required: true,
              onAccept: function() {
                console.log('Add logic for the required Necessary here');
              }
            },
            {
              id: "analytics",
              name: "Analytics",
              description: "<p>These cookies help us improve the site by tracking which pages are most popular and how visitors move around the site.</p>",
              required: false,
              onAccept: function() {
                if (typeof gtag !== 'undefined') {
                  gtag('consent', 'update', {
                    analytics_storage: 'granted',
                  });
                }
                if (typeof dataLayer !== 'undefined') {
                  dataLayer.push({
                    'event': 'consent_accepted_analytics',
                  });
                }
              },
              onReject: function() {
                if (typeof gtag !== 'undefined') {
                  gtag('consent', 'update', {
                    analytics_storage: 'denied',
                  });
                }
              }
            },
            {
              id: "advertising",
              name: "Advertising",
              description: "<p>These cookies provide extra features and personalization to improve your experience. They may be set by us or by partners whose services we use.</p>",
              required: false,
              onAccept: function() {
                if (typeof gtag !== 'undefined') {
                  gtag('consent', 'update', {
                    ad_storage: 'granted',
                    ad_user_data: 'granted',
                    ad_personalization: 'granted',
                  });
                }
                if (typeof dataLayer !== 'undefined') {
                  dataLayer.push({
                    'event': 'consent_accepted_advertising',
                  });
                }
              },
              onReject: function() {
                if (typeof gtag !== 'undefined') {
                  gtag('consent', 'update', {
                    ad_storage: 'denied',
                    ad_user_data: 'denied',
                    ad_personalization: 'denied',
                  });
                }
              }
            },
            {
              id: "functional",
              name: "Functional",
              description: "",
              required: false,
              onAccept: function() {
                if (typeof gtag !== 'undefined') {
                  gtag('consent', 'update', {
                    functionality_storage: 'granted',
                  });
                }
                if (typeof dataLayer !== 'undefined') {
                  dataLayer.push({
                    'event': 'consent_accepted_functional',
                  });
                }
              },
              onReject: function() {
                if (typeof gtag !== 'undefined') {
                  gtag('consent', 'update', {
                    functionality_storage: 'denied',
                  });
                }
              }
            },
            {
              id: "third_party",
              name: "Third-Party",
              description: "",
              required: false,
              onAccept: function() {
                console.log('Add accept logic for Third-Party');
              },
              onReject: function() {
                console.log('Add reject logic for Third-Party');
              }
            }
          ],
          text: {
            banner: {
              description: "<p>We use cookies on our site to enhance your user experience, provide personalized content, and analyze our traffic. <a href=\"https://your-website.com/cookie-policy\" target=\"_blank\">Cookie Policy.</a></p>",
              acceptAllButtonText: "Accept all",
              acceptAllButtonAccessibleLabel: "Accept all cookies",
              rejectNonEssentialButtonText: "Reject non-essential",
              rejectNonEssentialButtonAccessibleLabel: "Reject non-essential",
              preferencesButtonText: "Preferences",
              preferencesButtonAccessibleLabel: "Toggle preferences"
            },
            preferences: {
              title: "Customize your cookie preferences",
              description: "<p>We respect your right to privacy. You can choose not to allow some types of cookies. Your cookie preferences will apply across our website.</p>",
              creditLinkText: "Get this banner for free",
              creditLinkAccessibleLabel: "Get this banner for free"
            }
          },
          position: {
            banner: "bottomCenter"
          }
        });
        console.log('Cookie consent banner initialized with bottomCenter position');
        
        // Check if banner element exists after initialization
        setTimeout(() => {
          const banner = document.getElementById('silktide-banner');
          const cookieIcon = document.getElementById('silktide-cookie-icon');
          console.log('Banner element exists:', !!banner);
          console.log('Cookie icon element exists:', !!cookieIcon);
          if (banner) {
            console.log('Banner display style:', window.getComputedStyle(banner).display);
            console.log('Banner visibility:', window.getComputedStyle(banner).visibility);
          }
        }, 500);
      } else {
        console.warn('silktideCookieBannerManager is not available');
      }
    };

    // Check if CSS is already loaded
    let link = document.getElementById('silktide-consent-manager-css');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'stylesheet';
      link.id = 'silktide-consent-manager-css';
      link.href = '/cookie-banner/silktide-consent-manager.css';
      document.head.appendChild(link);
    }

    // Check if script is already loaded
    let script = document.querySelector('script[src="/cookie-banner/silktide-consent-manager.js"]');
    if (script) {
      // Script already exists, check if manager is available
      if (window.silktideCookieBannerManager && window.silktideCookieBannerManager.updateCookieBannerConfig) {
        initializeCookieConsent();
      } else {
        // Wait a bit for script to fully initialize
        const checkManager = setInterval(() => {
          if (window.silktideCookieBannerManager && window.silktideCookieBannerManager.updateCookieBannerConfig) {
            clearInterval(checkManager);
            initializeCookieConsent();
          }
        }, 50);
        
        // Stop checking after 5 seconds
        setTimeout(() => clearInterval(checkManager), 5000);
      }
      return;
    }

    // Load JS - Add to head like the original script
    script = document.createElement('script');
    script.src = '/cookie-banner/silktide-consent-manager.js';
    // Don't use async to ensure script loads before updateCookieBannerConfig is called
    // This matches the original script tag behavior
    
    script.onload = () => {
      // The script initializes silktideCookieBannerManager immediately when loaded
      // Wait a moment to ensure initialization is complete
      setTimeout(() => {
        if (window.silktideCookieBannerManager && window.silktideCookieBannerManager.updateCookieBannerConfig) {
          initializeCookieConsent();
        } else {
          // Fallback: check periodically if not immediately available
          const checkManager = setInterval(() => {
            if (window.silktideCookieBannerManager && window.silktideCookieBannerManager.updateCookieBannerConfig) {
              clearInterval(checkManager);
              initializeCookieConsent();
            }
          }, 50);
          
          // Stop checking after 5 seconds
          setTimeout(() => clearInterval(checkManager), 5000);
        }
      }, 100);
    };

    script.onerror = () => {
      console.error('Failed to load silktide-consent-manager.js');
    };

    // Add to head like the original HTML script tag
    document.head.appendChild(script);

    // Cleanup function
    return () => {
      // Remove link if component unmounts
      const existingLink = document.getElementById('silktide-consent-manager-css');
      if (existingLink) {
        existingLink.remove();
      }
      // Note: We don't remove the script as it may be needed globally
    };
  }, []);

  return null; // This component doesn't render anything
};

export default CookieConsent;
